import { useQuery } from "react-query";
import { getClients } from "../../shipment-editor/lib/shipmentData";

export const useClients = (clientFilterId) => {
    return useQuery({
        queryKey: ["clients", clientFilterId],
        initialData: [],
        queryFn: () => getClients({ clientFilter: clientFilterId }),
    });
};
